exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-transactions-popup-container {\r\n    background-color: #F0F0F0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/common/view-transactions-popup/view-transactions-popup.component.css
// module id = ../../../../../src/app/shared/components/common/view-transactions-popup/view-transactions-popup.component.css
// module chunks = main